import { render, staticRenderFns } from "./Joinbeta.vue?vue&type=template&id=3ad97be7&scoped=true"
import script from "./Joinbeta.vue?vue&type=script&lang=js"
export * from "./Joinbeta.vue?vue&type=script&lang=js"
import style0 from "./Joinbeta.vue?vue&type=style&index=0&id=3ad97be7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad97be7",
  null
  
)

export default component.exports